<template>
  <div class="form">
    <el-form ref="form" :rules="rules" :model="RetrievePasswordByPhoneDTO" >
      <div class="form-input">
        <el-row>
          <el-col :span="24">
            <el-form-item class="form_inputs" label="统一社会信用代码：" prop="uscCode">
              <el-input placeholder="请输入统一社会信用代码" v-model="RetrievePasswordByPhoneDTO.uscCode" style="width:220px;"></el-input>
              <el-radio v-model="RetrievePasswordByPhoneDTO.userType" label="2">企业用户</el-radio>
              <el-radio v-model="RetrievePasswordByPhoneDTO.userType" label="3">个人用户</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="form_inputs" label="手机号码:" prop="mobilePhone">
              <el-input placeholder="请输入手机号码" v-model="RetrievePasswordByPhoneDTO.mobilePhone" style="width:180px;"></el-input>
              <el-input placeholder="短信验证码" v-model="RetrievePasswordByPhoneDTO.msgCode"></el-input>
              <el-button type="primary" @click="getMsgCode()">获取验证码</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="forget">请您提交注册联系人手机号，登录账号将发送至联系人手机。</div>
      <el-form-item>
        <el-button type="primary" @click="cancel()">取消</el-button>
        <el-button type="primary" native-type="submit" @click="submit()">找回账号</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import axios from 'axios'
import { Message } from 'element-ui'

export default {
  name: 'forget',
  data () {
    return {
      rules: {
        uscCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: ['blur', 'change'] }
        ],
        mobilePhone: [
          { required: true, message: '请输入手机号', trigger: ['blur', 'change'] }
        ]
      },
      RetrievePasswordByPhoneDTO: {
        uscCode: '',
        userType: '2',
        mobilePhone: '',
        msgCode: ''
      }
    }
  },
  methods: {
    getMsgCode () {
      axios.post(`${process.env.VUE_APP_SERVER_URL}/ucenter/forget/front/getMsgByUscCode`, this.RetrievePasswordByPhoneDTO)
        .then(function (response) {
          const data = response.data
          if (data.status !== 200) {
            Message({
              message: data.message,
              type: 'warning'
            })
            return
          }
          Message({
            message: '验证码已发送，请注意查收！',
            type: 'success'
          })
        })
    },
    cancel () {
      this.$router.push({ path: '/login' })
    },
    submit () {
      if (!this.RetrievePasswordByPhoneDTO.msgCode) {
        Message({
          message: '请输入验证码',
          type: 'error'
        })
        return
      }
      axios.post(`${process.env.VUE_APP_SERVER_URL}/ucenter/forget/front/sendAccount`, this.RetrievePasswordByPhoneDTO)
        .then(function (response) {
          const data = response.data
          if (data.status !== 200) {
            Message({
              message: data.message,
              type: 'warning'
            })
            return
          }
          Message({
            message: '账号已发送，请注意查收！',
            type: 'success'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/base.scss';
  .form {
    width: 700px;
    margin: 20px auto;
    .form_inputs{
      display: flex;
    }
    .el-input{
      width: 130px;
      margin-right: 20px;
    }
    .el-row{
      margin-bottom: 30px;
    }
  }

  .forget {
    margin: 40px;
    font-size: 14px;
    color: #d43c33;
  }

</style>
